var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('UnPatrolListComponent',{attrs:{"typeName":"設備点検 未点検一覧","type":4,"settionStrageName":"FacilityUnpatrolListStorageItemName"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }